import { render, staticRenderFns } from "./collectInfo.vue?vue&type=template&id=c7a4747a&scoped=true"
import script from "./collectInfo.vue?vue&type=script&lang=js"
export * from "./collectInfo.vue?vue&type=script&lang=js"
import style0 from "./collectInfo.vue?vue&type=style&index=0&id=c7a4747a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7a4747a",
  null
  
)

export default component.exports